// eslint-disable-next-line import/prefer-default-export
export const ADDEDMENU_CHANGE = "ADDEDMENU_CHANGE";
export const REMOVEMENU_CHANGE = "REMOVEMENU_CHANGE";
export const UPDATEMENU_COUNT = "UPDATEMENU_COUNT";
export const CLEAR_CART = 'CLEAR_CART';
